module.exports = __webpack_public_path__ + "0cd2f43621e8554ae312d54d0c8e4635.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/null.png
// module id = 276
// module chunks = 0